import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { Helmet } from "react-helmet";

import Menu from "./Menu";
import App from "./App";
import "./App.scss";

const router = createHashRouter([
  {
    path: "/",
    element: <Menu />,
  },
  {
    path: "/:id",
    element: <App />,
  },
]);

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Helmet>
      <title>Radu's Recipes</title>
      <meta name="description" content="All my favourite recipes" />
    </Helmet>
    <RouterProvider router={router} />
  </React.StrictMode>
);
